import {FC} from 'react';
import {Box, Chip, Typography} from '@mui/material';
import {KeyboardArrowDown, KeyboardArrowUp} from '@mui/icons-material';
import type {MagicCardDisplayStatus} from '../../utils/magicCardSummary';

interface Props {
    status: MagicCardDisplayStatus;
    caption: string | null;
    expanded?: boolean;
    onClick?: () => void;
}

const CONFIG: Record<MagicCardDisplayStatus, {
    label: string;
    color: 'success' | 'info' | 'default' | 'error' | 'secondary';
    variant: 'filled' | 'outlined';
}> = {
    READY: {label: '준비됨', color: 'success', variant: 'filled'},
    GENERATING: {label: '생성 중', color: 'info', variant: 'filled'},
    QUEUED: {label: '대기 중', color: 'default', variant: 'filled'},
    FAILED: {label: '실패', color: 'error', variant: 'filled'},
    CACHE_ONLY: {label: '캐시 있음', color: 'secondary', variant: 'outlined'},
    NONE: {label: '미생성', color: 'default', variant: 'outlined'},
};

export const MagicCardStatusChip: FC<Props> = ({status, caption, expanded, onClick}) => {
    const cfg = CONFIG[status];
    const clickable = typeof onClick === 'function';
    const ArrowIcon = expanded ? KeyboardArrowUp : KeyboardArrowDown;
    return (
        <Box display="flex" flexDirection="column" gap={0.25}>
            <Chip
                label={cfg.label}
                size="small"
                color={cfg.color}
                variant={cfg.variant}
                clickable={clickable}
                onClick={onClick}
                deleteIcon={clickable ? <ArrowIcon /> : undefined}
                onDelete={clickable ? onClick : undefined}
                aria-label={clickable ? (expanded ? '매직카드 패널 접기' : '매직카드 패널 펼치기') : undefined}
                sx={{width: 'fit-content'}}
            />
            {caption && (
                <Typography variant="caption" color="text.secondary" sx={{fontSize: '0.7rem'}}>
                    {caption}
                </Typography>
            )}
        </Box>
    );
};
